module.exports = __webpack_public_path__ + "img/sptx2.2701abb9.png";